import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundL1Alpha,
    paddingTop: theme.spacing[5],
    paddingBottom: theme.spacing[10],
    paddingHorizontal: theme.spacing[5],
  },
  contentWrapper: {
    alignItems: 'flex-start',
  },
  avatar: {
    borderRadius: theme.borderRadius.xxs,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
  },
  footerContainer: {
    justifyContent: 'space-between',
  },
}));
